
import Multiselect from 'vue-multiselect'
import {  Component, Prop } from 'vue-property-decorator'
import { DEFAULT_MAX_UPLOAD_SIZE_MB } from '../helpers/constants'
import Mixin from '../helpers/mixin'
import { IFormField, FormFieldTypes } from '../types/forms'

@Component({})
export default class Formfield extends Mixin {
  @Prop() field: IFormField

  @Prop() value: any

  @Prop() error: boolean

  formFieldTypes = FormFieldTypes

  get label(): string {
    return this.field.label ?? this.$options?.filters?.t(this.field.labelTranslateKey)
  }

  get placeholder(): string {
    return this.field.placeholderTranslateKey ? this.$options?.filters?.t(this.field.placeholderTranslateKey) : this.label
  }

  get maxFileSizeInMb(): number {
    return this.field.maxFileSizeInMb || DEFAULT_MAX_UPLOAD_SIZE_MB
  }

  get showExtensionError(): boolean {
    return this.field.type === FormFieldTypes.File && !!this.value &&
      !!this.field.allowedExtensions &&
      !this.field.allowedExtensions.includes(`.${this.value.name.split('.').pop()}`)
  }

  get showMaxFileSizeError(): boolean {
    return this.field.type === FormFieldTypes.File && !!this.value &&
      this.value.size / 1024 / 1024 > this.maxFileSizeInMb
  }

  triggerFileUpload(): void {
    (this.$refs.fileInput as HTMLInputElement).click()
  }

  setTextHoverOnMultiselect(): void {
    if(this.isPhone || this.isTabletP) return
    const tansitionTimePerPixel = 0.015
    const multiselect = this.$refs.multiselect as Multiselect
    if (multiselect) {
      const textElements = multiselect.$el.querySelectorAll('.multiselect__option') as unknown as HTMLElement[]
      // add event listeners for each multiselect option
      textElements.forEach((textBox) => {

        // set transition to left on mouse enter
        textBox.addEventListener('mouseenter', () => {
          const textWidth = textBox.clientWidth
          const boxWidth = parseFloat(getComputedStyle(multiselect.$el).width)
          const translateVal = Math.min(boxWidth - textWidth, 0)
          if (translateVal >= 0) textBox.classList.add('no-hover-scroll')
          const translateTime = - tansitionTimePerPixel * translateVal + "s"
          textBox.style.transitionDuration = translateTime
          textBox.style.transitionTimingFunction = 'linear'
          textBox.style.transform = `translateX(${translateVal}px)`
        })

        // set transition back to 0 to scroll back to the start of the text
        textBox.addEventListener('mouseleave', () => {
          textBox.style.transitionDuration = '0.3s'
          textBox.style.transform = 'translateX(0)'
          textBox.classList.remove('hover-scroll')
        })
      })
    }
  }

  mounted(): void {
    if (this.field.type === FormFieldTypes.Dropdown) this.$nextTick(() => this.setTextHoverOnMultiselect())
  }
}
